import { apiFetch } from "./client";
import type { Page, RateCard } from "./types";

export interface RateCardListParams {
  haulier_id?: number;
  limit?: number;
  offset?: number;
}

export interface RateCardInput {
  haulier_id: number;
  effective_from: string;
  effective_to?: string | null;
  basis?: string;
  distance_band?: string | null;
  pallet_band_min?: number | null;
  pallet_band_max?: number | null;
  notice_hours_threshold?: number;
  rate_standard: number;
  rate_emergency?: number | null;
  rate_out_of_hours?: number | null;
  rate_weekend?: number | null;
  currency?: string;
  return_mode?: string | null;
  return_value?: number | null;
}

export interface RateCardOverviewCustomer {
  id: number;
  customer_no: string;
  name: string;
  address: string | null;
  postcode: string | null;
}

export interface RateCardOverviewCard {
  id: number;
  effective_from: string;
  effective_to: string | null;
  basis: string;
  distance_band: string | null;
  pallet_band_min: number | null;
  pallet_band_max: number | null;
  notice_hours_threshold: number;
  rate_standard: number;
  rate_emergency: number | null;
  rate_out_of_hours: number | null;
  rate_weekend: number | null;
  currency: string;
  return_mode: string | null;
  return_value: number | null;
  customers: RateCardOverviewCustomer[];
}

export interface RateCardOverviewHaulier {
  id: number;
  haulier_code: string;
  name: string;
  is_active: boolean;
  account_manager_name: string | null;
  account_manager_email: string | null;
  account_manager_phone: string | null;
  rate_cards: RateCardOverviewCard[];
}

export async function getRateCard(id: number): Promise<RateCard> {
  return apiFetch<RateCard>(`/rate-cards/${id}`);
}

export async function getRateCardOverview(): Promise<RateCardOverviewHaulier[]> {
  return apiFetch<RateCardOverviewHaulier[]>("/rate-cards/overview");
}

export async function listRateCards(
  params: RateCardListParams = {},
): Promise<Page<RateCard>> {
  const qs = new URLSearchParams();
  if (params.haulier_id !== undefined) qs.set("haulier_id", String(params.haulier_id));
  qs.set("limit", String(params.limit ?? 50));
  qs.set("offset", String(params.offset ?? 0));
  return apiFetch<Page<RateCard>>(`/rate-cards?${qs.toString()}`);
}

export async function createRateCard(data: RateCardInput): Promise<RateCard> {
  return apiFetch<RateCard>("/rate-cards", { method: "POST", body: JSON.stringify(data) });
}

export async function updateRateCard(
  id: number,
  data: Partial<RateCardInput>,
): Promise<RateCard> {
  return apiFetch<RateCard>(`/rate-cards/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteRateCard(id: number): Promise<unknown> {
  return apiFetch(`/rate-cards/${id}`, { method: "DELETE" });
}
